module.exports = __webpack_public_path__ + "media/eyejack-webar-gallery-comp.d9c064d7.mp4";